module.exports = __webpack_public_path__ + "static/img/standard_logo_events.e927f6d.png";